import { ScrollSpy } from 'bootstrap'
import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class ProductLayout extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            filterNav: null,
            main: null
        }
    }

    prepare() {
        this.resize()
        Scroll.on('resize', this.handleResize)
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        if (!(this.ref.filterNav && this.ref.main)) {
            return
        }

        this.ref.main.style.minHeight = `${this.ref.filterNav.offsetHeight}px`
    }
}